// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__B3-0N","header":"MergedInvoice_header__3Esxu"};